// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2358":"8a2b217b9fa53b2d","5630":"463263fc5c0f2b6a","6726":"6d0536fa12160466","7933":"ba022b7b84b5b515","9334":"a58ca0d825ed1733"}[chunkId] + ".css";
};